import React, {useContext, useEffect, useState} from 'react';
import { useHistory, Link } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import axios from 'axios';
import { apiRoutes } from '../../../AppSettings';

const SideNav = props => {
    const patient = props.user;
    const history = useHistory();
    const { userState, resetUserState } = useContext(AuthContext); 
    const [messageCount, setMessageCount] = useState(0); 

    const logouthandler = () => {
        resetUserState();
        history.push('/');
    };


    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer ' + userState.token
            }
        };

        // axios.get(apiRoutes.GetMessageCount + patient.patientId + '/' + userState.userType, options)
        //     .then((response) => {
        //     if (response.status === 200) {
        //         const data = response.data;
        //         console.log('messageCount: ') 
        //         console.log(data)
        //         setMessageCount(data.result);
        //     }
        // }, (error) => {
        //     console.log(error);
        // });
    }, []);

    return (
        <div className="profile-sidebar">
            <div className="widget-profile pro-widget-content">
                <div className="profile-info-widget">
                    <a href="#" className="booking-doc-img">
                        <img src={ Util.loadImage(patient.profileImage)} alt="User" />
                    </a>
                    <div className="profile-det-info">
                        <h3>{patient.firstName} {patient.lastName}</h3>
                        <div className="patient-details">
                            {
                                patient.dob != undefined &&
                                <h5><i className="fas fa-birthday-cake"></i> 
                                    {
                                        new Intl.DateTimeFormat("en-GB", {
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit"
                                        }).format(new Date(patient.dob+".000Z"))
                                    }, {
                                        Util.getAge(new Date(patient.dob), new Date())
                                    } 
                                </h5>
                            }
                            {
                                patient.state != undefined && 
                                <h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> {patient.state}, {patient.country}</h5>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="dashboard-widget">
                <nav className="dashboard-menu">
                    <ul>
                        <li className={props.applyCssFor === 'dashboard' ? 'active' : ''} >
                            <a href="#/patientdashboard">
                                <i className="fas fa-columns"></i>
                                <span>Dashboard</span>
                            </a>
                        </li>
                        <li>
                            <a href="favourites.html">
                                <i className="fas fa-bookmark"></i>
                                <span>Favourites</span>
                            </a>
                        </li>
                        {/*<li>*/}
                        {/*    <Link to={*/}
                        {/*        {*/}
                        {/*            pathname: `/chat`*/}
                        {/*        }*/}
                        {/*    }><i className="far fa-comments"></i>*/}
                        {/*     <span>Message</span>*/}
                        {/*        {*/}
                        {/*            messageCount != undefined && messageCount != 0*/}
                        {/*            && <small className="unread-msg">{messageCount}</small>*/}
                        {/*        }*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                        <li className={props.applyCssFor === 'profilesetting' ? 'active' : ''}>
                            <a href="#/patientprofilesetting">
                                <i className="fas fa-user-cog"></i>
                                <span>Profile Settings</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'changepassword' ? 'active' : ''}>
                            <a href="#/patchangepassword">
                                <i className="fas fa-lock"></i>
                                <span>Change Password</span>
                            </a>
                        </li>
                        <li>
                           <Link onClick={logouthandler}>
                                <i className="fas fa-sign-out-alt"></i>
                                <span>Logout</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>

        </div>
    );
};

export default SideNav;